<template>
  <div>
    <div class="detailPic" v-bind:class="{ winner: winnerIco }">
      <van-image :src="userDetail.avatar" />
    </div>
    <div class="nameTitle">
      {{ userDetail.serialNumber }} | {{ userDetail.username }}
    </div>
    <div class="detailVotes">
      {{ userDetail.votenum }}票 <span class="icoHot"></span>
    </div>
    <div class="detailCity">
      <span>{{ userDetail.address }}</span
      ><span>{{ userDetail.attachedUnits }}</span>
    </div>
    <div class="detailAbout" v-html="userDetail.introduction"></div>
  </div>
</template>
<script>
import { Image as VanImage } from "vant";
export default {
  name: "detailContent",
  props: ["userDetail", "winnerIco"],
  components: {
    VanImage,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>